//仓储管理列表基本信息
export const searchColumns = (ctx) => {
  return [
    {
      name: '合同编号',
      prop: 'contractNo',
      type: 'input',
    },
    {
      name: '合同名称',
      prop: 'contractName',
      type: 'input',
    },
    {
      name: '项目名称',
      prop: 'projectName',
      searchType: 'projectListWumao',
      type: 'searchTableSpec',
      isMultiple: true,
      extraData: {
        projectInitiationStatusList: ['PIS04', 'PIS05', 'PIS07', 'PIS08'],
        platformtCompany: ctx.userInfo.companyCode,
        platformtCompanyName: ctx.userInfo.companyName,
        applyCompanyName: ctx.userInfo.companyName,
        applyCompanyNo: ctx.userInfo.companyCode,
      },
      changeMethod: 'changeMethod',
    },
    {
      name: '供应商名称',
      prop: 'supplierName',
      type: 'searchTableSpec',
      searchType: 'partner',
      extraData: {
        departmentCode: ctx.departmentCode,
        companyCode: ctx.companyCode,
      },
      isMultiple: true,
      changeMethod: 'changeMethod',
    },
    {
      name: '业务部门',
      prop: 'applyDepartment',
      type: 'select',
      options: ctx.departmentList,
      changeMethod: 'changeMethod',
    },
    {
      name: '单据状态',
      prop: 'contractStatus',
      type: 'select',
      options: ctx.serviceContractStatus,
      changeMethod: 'changeMethod',
    },
    {
      name: '合同类型',
      prop: 'contractType',
      type: 'select',
      options: ctx.serviceContractType,
      changeMethod: 'changeMethod',
    },
  ];
};
